import { render, staticRenderFns } from "./RecoverPassForm.vue?vue&type=template&id=9d30b3ac&scoped=true"
import script from "./RecoverPassForm.vue?vue&type=script&lang=js"
export * from "./RecoverPassForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassForm.vue?vue&type=style&index=0&id=9d30b3ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d30b3ac",
  null
  
)

export default component.exports